import { render, staticRenderFns } from "./invoice-edit.vue?vue&type=template&id=b8a41968&"
import script from "./invoice-edit.vue?vue&type=script&lang=js&"
export * from "./invoice-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports